"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var useClientFiltering_1 = require("./useClientFiltering");
var useClientPaging_1 = require("./useClientPaging");
var useClientSorting_1 = require("./useClientSorting");
var useClientFiltersWithOptions = function (data, filterOptions) {
    var _a = filterOptions.filters, filters = _a === void 0 ? [] : _a;
    return useClientFiltering_1.default(data, filters);
};
var useClientSortingWithOptions = function (data, sortOptions) {
    var _a = sortOptions.enable, enableSort = _a === void 0 ? false : _a, _b = sortOptions.customComparators, customComparators = _b === void 0 ? {} : _b;
    var _c = useClientSorting_1.default(enableSort ? data : [], { customComparators: customComparators }), sorted = _c.sorted, sortingRest = __rest(_c, ["sorted"]);
    return __assign({ sorted: enableSort ? sorted : data }, sortingRest);
};
var useClientPagingWithOptions = function (data, pagingOptions) {
    var _a = pagingOptions.disable, disablePaging = _a === void 0 ? false : _a;
    var pagingHandlers = useClientPaging_1.default(disablePaging ? [] : data);
    if (disablePaging) {
        return { page: data, currentPageNumber: 0, pageCount: 1, totalItemCount: data.length };
    }
    return pagingHandlers;
};
function useListingContextClientConsumer(data, options) {
    var _a = options || {}, _b = _a.filtering, filtering = _b === void 0 ? {} : _b, _c = _a.sorting, sorting = _c === void 0 ? {} : _c, _d = _a.paging, paging = _d === void 0 ? {} : _d;
    var dataWithFallback = !!data && data || [];
    var filtered = useClientFiltersWithOptions(dataWithFallback, filtering);
    var _e = useClientSortingWithOptions(filtered, sorting), sorted = _e.sorted, sortingRest = __rest(_e, ["sorted"]);
    // re-assign for easy consumption without polluting the hooks with garbage names
    var _f = useClientPagingWithOptions(sorted, paging), page = _f.page, pageCount = _f.pageCount, totalItemCount = _f.totalItemCount, currentPage = _f.currentPageNumber, onNext = _f.goToNextPage, onPrevious = _f.goToPreviousPage;
    return __assign({ page: page, pagination: {
            currentPage: currentPage,
            pageCount: pageCount,
            totalItemCount: totalItemCount,
            onNext: onNext,
            onPrevious: onPrevious,
        } }, sortingRest);
}
exports.default = useListingContextClientConsumer;
//# sourceMappingURL=useListingContextClientConsumer.js.map